import React from 'react';
import SvgElement from './SvgElement';

const HomeIcon = props => (
  <SvgElement {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.707 25.455">
    <g id="_004-house" data-name="004-house" transform="translate(0.57 0.558)">
      <path id="Path_27" data-name="Path 27" d="M25.333,22.149,13.3,11.389a.338.338,0,0,0-.068-.053.712.712,0,0,0-.962-.016L.237,22.08a.711.711,0,0,0,.947,1.062L3.351,21.2V33.75a1.79,1.79,0,0,0,1.788,1.788h3.8a1.679,1.679,0,0,0,1.678-1.678V27.481a.258.258,0,0,1,.258-.258H14.7a.258.258,0,0,1,.258.258V33.86a1.679,1.679,0,0,0,1.678,1.678h3.8a2.032,2.032,0,0,0,1.788-2.24V21.27l2.167,1.941a.715.715,0,0,0,1-.058A.724.724,0,0,0,25.333,22.149ZM20.8,25.656v7.631c0,.51-.252.82-.368.82h-3.8a.258.258,0,0,1-.258-.258V27.481A1.679,1.679,0,0,0,14.7,25.8H10.866a1.679,1.679,0,0,0-1.678,1.678V33.86a.258.258,0,0,1-.258.258h-3.8a.369.369,0,0,1-.368-.368V19.929L12.748,12.8,20.8,20v5.659Z" transform="translate(0 -11.141)" />
    </g>
  </SvgElement>
);

export default HomeIcon;
